module.exports = __webpack_public_path__ + "img/img_information.a477df72.png";